
import { createFeatureSelector,createSelector } from '@ngrx/store';
import { AccountsReceivableLedgerTypeEnum } from '../../entities/accounts-receivable-ledger.entity';
import {
selectAllSurchargeRate,selectSurchargeRateEntities,selectSurchargeRateFetched,SurchargeRateState,SURCHARGE_RATE_KEY
} from '../reducers/surcharge-rate.reducer';
import { SurchargeRateEntity, SurchargeRateNameEnum } from '../../entities/surcharge-rate.entity';
import { Dictionary } from '@ngrx/entity';



const selectState = createFeatureSelector<SurchargeRateState>(SURCHARGE_RATE_KEY);

export const getSurchargeRate = createSelector(selectState, selectAllSurchargeRate);
export const getSurchargeRateDictionary = createSelector(selectState, selectSurchargeRateEntities);
export const getSurchargeRateByArlType = (props: { arlType: AccountsReceivableLedgerTypeEnum }) => createSelector(getSurchargeRateDictionary, (dictionary) => {
    if (props.arlType) {
        return surChargeForArlType(props.arlType, dictionary);
    }
    return undefined;
});
export const getSurchargeRateFetched = createSelector(selectState, selectSurchargeRateFetched);
export function surChargeForArlType (arlType: AccountsReceivableLedgerTypeEnum, dictionary:  Dictionary<SurchargeRateEntity>){
    // console.log('surChargeForArlType', arlType, dictionary);
    if (arlType) {
        switch (arlType) {
            case AccountsReceivableLedgerTypeEnum.EmployeeArl:
                return dictionary[SurchargeRateNameEnum.Lohn]
            case AccountsReceivableLedgerTypeEnum.ResourceArl:
                return dictionary[SurchargeRateNameEnum.Ressource]
            case AccountsReceivableLedgerTypeEnum.Arl:
                return dictionary[SurchargeRateNameEnum.Leistung]
            case AccountsReceivableLedgerTypeEnum.ExternalService:
                return dictionary[SurchargeRateNameEnum.ExternalService]
            case AccountsReceivableLedgerTypeEnum.Other:
                return dictionary[SurchargeRateNameEnum.Other]
            case AccountsReceivableLedgerTypeEnum.MaterialArl:
                return dictionary[SurchargeRateNameEnum.Material]
            default: {
                console.error('getSurchargeRateByArlType for arlType ' + arlType + ' not implemented');
                return null;
            }
        }
    }
    return undefined;
}
export function arlTypeForSurchargeRate (surchargeRate: SurchargeRateNameEnum){
    switch (surchargeRate) {
        case SurchargeRateNameEnum.Lohn:
            return AccountsReceivableLedgerTypeEnum.EmployeeArl;
        case SurchargeRateNameEnum.Ressource:
            return AccountsReceivableLedgerTypeEnum.ResourceArl;
        case SurchargeRateNameEnum.Leistung:
            return AccountsReceivableLedgerTypeEnum.Arl;
        case SurchargeRateNameEnum.ExternalService:
            return AccountsReceivableLedgerTypeEnum.ExternalService;
        case SurchargeRateNameEnum.Other:
            return AccountsReceivableLedgerTypeEnum.Other;
        case SurchargeRateNameEnum.Material:
            return AccountsReceivableLedgerTypeEnum.MaterialArl;
        default: {
            console.error('arlTypeForSurchargeRate for surchargeRate ' + surchargeRate + ' not implemented');
            return null;
        }
    }
}
